module.exports = __webpack_public_path__ + "img/icon-dele.bbcc6f30.svg";